interface Props {
    className?: string
    FillColor?: string
}

export default function Pressemitteilung({className, FillColor}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M8.08 5.57143C7.92536 5.57143 7.8 5.68656 7.8 5.82857C7.8 6.39664 8.30144 6.85714 8.92 6.85714L11.72 6.85714C11.8746 6.85714 12 6.74202 12 6.6C12 6.03194 11.4986 5.57143 10.88 5.57143L8.08 5.57143Z"
                fill={FillColor}/>
            <path
                d="M8.08 8.14286C7.92536 8.14286 7.8 8.25798 7.8 8.4C7.8 8.96806 8.30144 9.42857 8.92 9.42857H11.72C11.8746 9.42857 12 9.31345 12 9.17143C12 8.60336 11.4986 8.14286 10.88 8.14286H8.08Z"
                fill={FillColor}/>
            <path
                d="M7.8 10.9714C7.8 10.8294 7.92536 10.7143 8.08 10.7143H10.88C11.4986 10.7143 12 11.1748 12 11.7429C12 11.8849 11.8746 12 11.72 12H8.92C8.30144 12 7.8 11.5395 7.8 10.9714Z"
                fill={FillColor}/>
            <path
                d="M8.08 13.2857C7.92536 13.2857 7.8 13.4008 7.8 13.5429C7.8 14.1109 8.30144 14.5714 8.92 14.5714H11.72C11.8746 14.5714 12 14.4563 12 14.3143C12 13.7462 11.4986 13.2857 10.88 13.2857H8.08Z"
                fill={FillColor}/>
            <path
                d="M13.4 13.5429C13.4 13.4008 13.5254 13.2857 13.68 13.2857H15.08C15.6986 13.2857 16.2 13.7462 16.2 14.3143C16.2 14.4563 16.0746 14.5714 15.92 14.5714H14.52C13.9014 14.5714 13.4 14.1109 13.4 13.5429Z"
                fill={FillColor}/>
            <path
                d="M13.68 15.8571C13.5254 15.8571 13.4 15.9723 13.4 16.1143C13.4 16.6823 13.9014 17.1429 14.52 17.1429H15.92C16.0746 17.1429 16.2 17.0277 16.2 16.8857C16.2 16.3176 15.6986 15.8571 15.08 15.8571H13.68Z"
                fill={FillColor}/>
            <path
                d="M13.4 10.9714C13.4 10.8294 13.5254 10.7143 13.68 10.7143H15.08C15.6986 10.7143 16.2 11.1748 16.2 11.7429C16.2 11.8849 16.0746 12 15.92 12H14.52C13.9014 12 13.4 11.5395 13.4 10.9714Z"
                fill={FillColor}/>
            <path
                d="M13.68 8.14286C13.5254 8.14286 13.4 8.25798 13.4 8.4C13.4 8.96806 13.9014 9.42857 14.52 9.42857H15.92C16.0746 9.42857 16.2 9.31344 16.2 9.17143C16.2 8.60336 15.6986 8.14286 15.08 8.14286H13.68Z"
                fill={FillColor}/>
            <path
                d="M13.4 5.82857C13.4 5.68656 13.5254 5.57143 13.68 5.57143H15.08C15.6986 5.57143 16.2 6.03194 16.2 6.6C16.2 6.74202 16.0746 6.85714 15.92 6.85714H14.52C13.9014 6.85714 13.4 6.39664 13.4 5.82857Z"
                fill={FillColor}/>
            <path
                d="M9.61005 21L17.6 21C18.3732 21 19 20.4244 19 19.7143L19 4.28572C19 3.57563 18.3732 3 17.6 3H6.4C5.6268 3 5 3.57563 5 4.28571L5 16.7663L9.61005 21ZM17.6 19.7143L10.6 19.7143L10.6 17.1429C10.6 16.4328 9.9732 15.8571 9.2 15.8571H6.4L6.4 4.28571L17.6 4.28572L17.6 19.7143ZM7.38995 17.1429H9.2V18.8051L7.38995 17.1429Z"
                fill={FillColor}/>
        </svg>
    )
}
